<template>
    <div class="mx-auto max-w-7xl">
        <div class="bg-white py-24">
            <div class="mx-auto max-w-7xl px-6 lg:px-8">
                <div
                    class="mx-auto flex max-w-2xl flex-col items-start justify-between gap-16 lg:mx-0 lg:max-w-none lg:flex-row"
                >
                    <div class="w-full lg:max-w-lg lg:flex-auto">
                        <h2 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                            {{ title }}
                        </h2>
                        <p class="mt-6 text-xl leading-8 text-gray-600">
                            {{ description }}
                        </p>
                        <img
                            :src="img_path"
                            alt=""
                            class="mt-16 aspect-[6/5] w-full rounded-2xl bg-gray-50 object-cover lg:aspect-auto lg:h-[34.5rem]"
                        />
                    </div>
                    <div class="w-full lg:mt-12 lg:max-w-xl lg:flex-auto">
                        <h3 class="sr-only">Blog Posts</h3>
                        <ul class="-my-8 divide-y divide-gray-100">
                            <li v-for="post in posts" :key="post.id" class="py-8">
                                <dl class="relative flex flex-wrap gap-x-3">
                                    <dt class="sr-only">Role</dt>
                                    <dd class="w-full flex-none text-lg font-semibold tracking-tight text-gray-900">
                                        <Link :href="route('blog.show', post.slug)">
                                            {{ post.title }}
                                            <span class="absolute inset-0" aria-hidden="true" />
                                        </Link>
                                    </dd>
                                    <dt class="sr-only">Description</dt>
                                    <dd class="mt-2 w-full flex-none text-base leading-7 text-gray-600">
                                        {{ post.description }}
                                    </dd>
                                    <dt class="sr-only">Salary</dt>
                                    <dd class="mt-4 text-base font-semibold leading-7 text-gray-900">
                                        <div class="flex gap-1">
                                            <Tag v-for="tag in getTags(post.tags)" :tag="tag" :key="tag" />
                                        </div>
                                    </dd>
                                </dl>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import Tag from '../Fragments/CategoryTag.vue'
import { Link } from '@inertiajs/vue3'

defineProps({
    title: String,
    description: String,
    img_path: String,
    posts: Array,
})

function getTags(tags) {
    return tags.map((o) => o['slug'])
}
</script>
